import { render, staticRenderFns } from "./JoinClassModal.vue?vue&type=template&id=7d200077&scoped=true"
import script from "./JoinClassModal.vue?vue&type=script&lang=js"
export * from "./JoinClassModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d200077",
  null
  
)

export default component.exports